import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmationSimpleComponent } from '../confirmation-simple/confirmation-simple.component';

@Component({
    selector: 'lib-confirmation-checkbox',
    templateUrl: './confirmation-checkbox.component.html',
    styleUrls: ['./confirmation-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationCheckboxComponent extends ConfirmationSimpleComponent {
  checked: boolean = false;
}
